import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=c3864cf8&scoped=true&"
import script from "./ServiceItem.vue?vue&type=script&lang=js&"
export * from "./ServiceItem.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItem.vue?vue&type=style&index=0&id=c3864cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3864cf8",
  null
  
)

export default component.exports